import { Component, OnInit } from "@angular/core";

@Component({
  standalone: false,
  selector: "app-internal",
  templateUrl: "./internal.component.html",
  styleUrls: ["./internal.component.css"],
})
export class InternalComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
